(function (ws) {
    'use strict';

    ws.views.specialCharactersValidation = ws.views.modal.extend({

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
        }

    });
}(westcon));
